import { Organization } from '@cast/types';

type OrganizationGroup = {
  label: string;
  items: Organization[];
  isEscalation: boolean;
};

type CategorizedOrganizations = {
  enterprises: Organization[];
  escalationEnterprises: Organization[];
  internalEnterprises: Organization[];
  defaults: Organization[];
  escalationDefaults: Organization[];
  internalDefaults: Organization[];
};

const groupLabels = {
  myOrgs: 'My organizations',
  customer: 'Customer organizations',
  internal: 'Internal organizations',
} as const;

export const buildOrganizationGroups = ({
  enterprises,
  escalationEnterprises,
  internalEnterprises,
  defaults,
  escalationDefaults,
  internalDefaults,
}: CategorizedOrganizations): OrganizationGroup[] => {
  const groups: OrganizationGroup[] = [];
  const myOrgs = [...enterprises, ...defaults];
  const customerOrgs = [...escalationEnterprises, ...escalationDefaults];
  const internalOrgs = [...internalEnterprises, ...internalDefaults];

  if (myOrgs.length > 0) {
    groups.push({
      label: groupLabels.myOrgs,
      items: myOrgs,
      isEscalation: false,
    });
  }

  if (customerOrgs.length > 0) {
    groups.push({
      label: groupLabels.customer,
      items: customerOrgs,
      isEscalation: true,
    });
  }

  if (internalOrgs.length > 0) {
    groups.push({
      label: groupLabels.internal,
      items: internalOrgs,
      isEscalation: true,
    });
  }

  return groups;
};
